import { Tag } from 'antd';
import FilterInput from "components/Form/filterInput";
import { useCallback, useEffect, useState } from "react";

import { Button } from "components/Button";
import { format } from "date-fns";
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { toTitleCase } from "utils/common";
const EmployeeListFilter = ({handleFilterDrawer, filters, handleInputChange, searchPlaceholder, handleFilterChange, loading, appliedFilterCount, handleExport, exportLoading}) => {
  const {
    department, departmentLoading,
    reportTo, reportToLoading,
    nationality, nationalityLoading,
    position, positionLoading,
    division, divisionLoading,
    costCenter, costCenterLoading
    
} = useSelector((state) => state.common);
const [searchParams, setSearchParams] = useSearchParams();

  const [appliedFilters, setAppliedFilters] = useState([])


  const setInputValue = useCallback((key) => {
    if(filters.length){
      let selectedValue = [...filters].find(item=> item.key === key)
      return selectedValue?.value
    }else{
      return ""
    }
  
  }, [filters]);

    useEffect(()=>{

    if(!departmentLoading && !reportToLoading && !nationalityLoading && !positionLoading && !divisionLoading ){

      console.log(filters, "LLLs")
      let _appliedFilters = [...filters].map(item=>{
        // Use existing label/value if available, otherwise resolve from searchParams
        let label = item.label || ""
        // Handle object values (like nationality array)
        let rawValue = item.value
        let value = ""
        if (Array.isArray(rawValue)) {
          value = rawValue.map(v => typeof v === 'object' ? (v.label || v.name || v.value || '') : String(v)).join(", ")
        } else if (typeof rawValue === 'object' && rawValue !== null) {
          value = rawValue.label || rawValue.name || rawValue.value || ""
        } else {
          value = rawValue || ""
        }
        
        // Only resolve if label/value is missing or is an ID
        if(!value || (item.key !== "search" && !isNaN(value) && value !== "" && !String(value).includes(","))){
          switch(item.key){
            case "resigned_date_after":
              let resigned_date_after = searchParams.get("resigned_date_after") || item.value || ""
              if(resigned_date_after){
                try {
                  value = format(new Date(resigned_date_after), "dd/MM/yyyy")
                } catch(e) {
                  value = resigned_date_after
                }
              }
              label = "" // Don't show label, just show the value
              break;
            case "resigned_date_before":
              let resigned_date_before = searchParams.get("resigned_date_before") || item.value || ""
              if(resigned_date_before){
                try {
                  value = format(new Date(resigned_date_before), "dd/MM/yyyy")
                } catch(e) {
                  value = resigned_date_before
                }
              }
              label = "" // Don't show label, just show the value
              break;
            case "eos_approved":
              value = toTitleCase(searchParams.get("eos_approved") || item.value || "")
              label = "" // Don't show label, just show the value
              break;
            case "employment_date_after":
              let date = searchParams.get("employment_date_after") || item.value || ""
              if(date){
                try {
                  value = format(new Date(date), "dd/MM/yyyy")
                } catch(e) {
                  value = date
                }
              }
              label = "" // Don't show label, just show the value
              break;
            case "employment_date_before":
              let date_before = searchParams.get("employment_date_before") || item.value || ""
              if(date_before){
                try {
                  value = format(new Date(date_before), "dd/MM/yyyy")
                } catch(e) {
                  value = date_before
                }
              }
              label = "" // Don't show label, just show the value
              break;
            case "search":
              value = toTitleCase(searchParams.get("search") || item.value || "")
              label = "" // Don't show label, just show the value
              break;
            case "report_to":
              let reportToId = searchParams.get("report_to") || item.value || ""
              if(reportToId && reportTo?.length){
                let selectedReportTo = reportTo.find(r=>r.user_id == reportToId)
                value = selectedReportTo ? `${selectedReportTo.first_name} ${selectedReportTo.last_name || ""}`.trim() : value || reportToId
                label = "" // Don't show label for report_to, just show the value
              }
              break;
            case "gender":
              value = toTitleCase(searchParams.get("gender") || item.value || "")
              label = "" // Don't show label for gender, just show the value
              break;
            case "department":
              let deptId = searchParams.get("department") || item.value || ""
              if(deptId && department?.length){
                let selectedDepartment = department.find(d=>d.id == deptId)
                value = selectedDepartment?.name || value || deptId
                label = "" // Don't show label for department, just show the value
              }
              break;
            case "position":
              let positionId = searchParams.get("position") || item.value || ""
              if(positionId && position?.length){
                let selectedPosition = position.find(p=>p.id == positionId)
                value = selectedPosition?.name || value || positionId
                label = "" // Don't show label for position, just show the value
              }
              break;
            case "nationality":
              let nationalityParams = searchParams.get("nationality") || (Array.isArray(item.value) ? item.value.map(v=>v.value || v).join(",") : item.value) || ""
              if(nationalityParams){
                nationalityParams = nationalityParams.split(",")
                let selectedNationality = nationality.filter(n=> nationalityParams.includes(n.id.toString()))
                value = selectedNationality.length > 0 ? selectedNationality.map(n=> n.name).join(", ") : (Array.isArray(item.value) ? item.value.map(v=>v.label || v.name || v).join(", ") : value)
                label = "" // Don't show label, just show the value
              }
              break;
            case "division":
              let divisionId = searchParams.get("division") || item.value || ""
              if(divisionId && division?.length){
                let selectedDivision = division.find(d=>d.id == divisionId)
                value = selectedDivision?.name || value || divisionId
                label = "" // Don't show label for division, just show the value
              }
              break;
            case "marital_status":
              value = toTitleCase(searchParams.get("marital_status") || item.value || "")
              label = "" // Don't show label for marital status, just show the value
              break;
            case "cost_center":
              let costCenterId = searchParams.get("cost_center") || item.value || ""
              if(costCenterId && costCenter?.length){
                let selectedCostCenter = costCenter.find(cc=>cc.id == costCenterId)
                value = selectedCostCenter?.name || value || costCenterId
                label = "" // Don't show label for cost center/store, just show the value
              }
              break;
            case "status":
              let statusValue = searchParams.get("status") || item.value || ""
              let selectedStatus = ""
              if(statusValue == "all"){
                selectedStatus = "All"
              }else{
                selectedStatus = statusValue == "true" ? "Active" : statusValue == "false" ? "Inactive" : ""
              }
              value = toTitleCase(selectedStatus || value || "")
              label = "" // Don't show label, just show the value
              break;

            default:
              label = "" // Don't show label, just show the value
              // Ensure value is always a string
              if (Array.isArray(item.value)) {
                value = item.value.map(v => typeof v === 'object' ? (v.label || v.name || v.value || '') : String(v)).join(", ")
              } else if (typeof item.value === 'object' && item.value !== null) {
                value = item.value.label || item.value.name || item.value.value || ""
              } else {
                value = String(item.value || "")
              }
          }
        }
        
        // Ensure final value is always a string
        let finalValue = value
        if (Array.isArray(finalValue)) {
          finalValue = finalValue.map(v => typeof v === 'object' ? (v.label || v.name || v.value || '') : String(v)).join(", ")
        } else if (typeof finalValue === 'object' && finalValue !== null) {
          finalValue = finalValue.label || finalValue.name || finalValue.value || ""
        } else {
          finalValue = String(finalValue || "")
        }
        
        // Apply title case for specific fields
        if (item.key === "gender" || item.key === "marital_status" || item.key === "eos_approved" || item.key === "status") {
          finalValue = toTitleCase(finalValue)
        }
        
        return {
          ...item,
          value: finalValue,
          label: "" // Always set label to empty string to show only value
        }
      })

     
      setAppliedFilters(_appliedFilters.filter(item=> item.value && item.key != "search"))

  
    }

 
  },[
    department,
    reportTo,
    nationality,
    position,
    division,
    costCenter,
    searchParams,
    
  ])


  const handleClose = (e, item) => {
    console.log(item, "llll")
    e.preventDefault();
    if(item.key == "search" || item.key == "employment_date_after" || item.key == "employment_date_before"){
      handleInputChange("", item.key, true)
    }else{
      handleFilterChange("", item.key, true)
    }
  }
  return (
    <div className="mb-4">
      <div className="row align-items-center g-3">
        <div className="col-lg-9 col-md-12">
          <div className="row g-3">
            <div className='col-sm-12 col-lg-4'>
              <FilterInput  
                defaultValue={setInputValue("search")} 
                onChange={e=>{handleInputChange(e.target.value, "search", true)}} 
                id="search"
                label={searchPlaceholder}
              />
            </div>
            <div className='col-sm-12 col-lg-8 d-flex flex-wrap align-items-center gap-2'>
              {appliedFilters.map((item, index) => (
                <Tag 
                  key={index}
                  icon={loading && <i className="fas fa-spinner fa-spin me-1" aria-hidden="true"></i>} 
                  className="mb-0" 
                  color="#D3001A"
                  style={{ 
                    borderRadius: "6px",
                    padding: "4px 12px",
                    fontSize: "13px",
                    fontWeight: "500",
                    border: "none"
                  }}
                  closeIcon={<i className="fa fa-times" style={{ fontSize: "11px" }}></i>} 
                  onClose={e=>handleClose(e, item)}
                >
                  {typeof item?.value === 'object' && item?.value !== null 
                    ? (Array.isArray(item.value) 
                        ? item.value.map(v => typeof v === 'object' ? (v.label || v.name || v.value || '') : v).join(", ")
                        : (item.value.label || item.value.name || item.value.value || ''))
                    : (item?.value || '')}
                </Tag>
              ))}
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-12 d-flex justify-content-end gap-2">
          <Button
            className="btn btn-primary shadow-sm"
            style={{ borderRadius: "8px" }}
            icon={"fa fa-download"}
            loading={exportLoading}
            onClick={handleExport}
          />
          <div className="position-relative">
            <Button
              onClick={handleFilterDrawer}
              icon="las la-filter"
              className="btn btn-outline-secondary shadow-sm"
              style={{ borderRadius: "8px" }}
            />
            {appliedFilterCount > 0 && (
              <span 
                className="badge bg-danger position-absolute top-0 start-100 translate-middle rounded-pill"
                style={{ fontSize: "10px", padding: "2px 6px" }}
              >
                {appliedFilterCount}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeListFilter;
